export enum ETREASURY_CARD_TYPES {
  PHYSICAL = 'physical',
  VIRTUAL = 'virtual'
}

export enum ETREASURY_CARD_STATUS {
  ACTIVE = 'active',
  INACTIVE = 'inactive',
  CLOSED = 'closed',
  EXPIRED = 'expired'
}
